import React, { Suspense, useRef, useState, useEffect, useMemo } from 'react';
import * as THREE from 'three';
import { Text } from '@react-three/drei';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader'
import { useLoader } from '@react-three/fiber'
import {  useThree, useFrame } from '@react-three/fiber'


function Particles({ count }) {
    const mesh = useRef()
    const gltf = useLoader(GLTFLoader, './hole.glb');
    const { mouse } = useThree();
    let lastTime = 0;
  
    const dummy = useMemo(() => new THREE.Object3D(), [])
    
    const particles = useMemo(() => {
      const temp = []
      for (let i = 0; i < count; i++) {
        const startLife = Math.random() * 3+0.3;
        const y = i%20;
        const randCircle = Math.round(Math.random()*20) * Math.PI * 2 / 20;
        const start = new THREE.Vector3(Math.sin(randCircle)* 3 + Math.random()/10,
                                        y,
                                        Math.cos(randCircle)* 3 + Math.random()/10);

        const randCircle2 = Math.round(Math.random()*20) * Math.PI * 2 / 20;
        const next = new THREE.Vector3(Math.sin(randCircle2) * 3 + Math.random()/10,
                                        y,
                                        Math.cos(randCircle2)* 3 + Math.random()/10);
        temp.push({ start, next, startLife, life: startLife });
      }
      return temp
    }, [count])
    
    useFrame(({clock}) => {
      
      // Go through each particle
      particles.forEach((particle, i) => {
        let { start, next } = particle
        // Change position
        dummy.position.copy(start.lerp(next, (particle.startLife - particle.life) / 3));
        dummy.scale.set(0.5,0.5,0.5);
        dummy.lookAt(new THREE.Vector3(0,i%20,0));
        dummy.updateMatrix()
        // And apply the matrix to the instanced mesh
        mesh.current.setMatrixAt(i, dummy.matrix)

        
        particle.life -= 0.1 * (clock.elapsedTime - lastTime);
        // console.log(particle.life)
        if(particle.life <= 0) {
          particle.startLife = Math.random() * 3+0.3;
          particle.life = particle.startLife;
          particle.start = particle.next.clone();
          const y = i%20;
          const randCircle = Math.round(Math.random()*20) * Math.PI * 2 / 20;
          particle.next = new THREE.Vector3(Math.sin(randCircle) * 3 + Math.random()/10,
                                            y,
                                            Math.cos(randCircle) * 3 + Math.random()/10);
        } 
      })
      mesh.current.instanceMatrix.needsUpdate = true;

      lastTime = clock.elapsedTime;
    })
    return (
      <>
        <instancedMesh ref={mesh} geometry={gltf.scene.children[0].geometry} args={[null, null, count]}>
          <meshPhongMaterial attach="material" color="#33aaff" transparent={true} opacity={0.5}/>
        </instancedMesh>
      </>
    )
  }
  

  
  
  export { Particles };